import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    
    if (!consent) {
      setIsVisible(true);
    } else if (consent === 'accepted') {
      loadTrackers();
    }
  }, []);

  const loadTrackers = () => {
    if (!document.getElementById('rd-station-script')) {
      const script = document.createElement('script');
      script.id = 'rd-station-script';
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://d335luupugsy2.cloudfront.net/js/loader-scripts/e0c3cda4-622f-4ed0-b9ff-535d8d61d6b5-loader.js';
      document.body.appendChild(script);
    }
  };

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
    loadTrackers();
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] p-4 md:p-6 z-50 flex flex-col md:flex-row justify-center items-center gap-6">
      <div className="text-sm text-gray-700 max-w-4xl text-center md:text-left leading-relaxed">
        Utilizamos cookies para melhorar a sua experiência em nosso site, personalizar conteúdo e anúncios, e analisar nosso tráfego. 
        Ao continuar navegando, você concorda com a nossa <a href="/termos-e-condicoes" className="text-[#890083] underline font-bold hover:text-purple-900 transition-colors">Política de Privacidade e Termos de Uso</a>.
      </div>
      <div className="flex gap-3 shrink-0">
        <button 
          onClick={handleDecline} 
          className="px-6 py-2 border-2 border-gray-300 text-gray-600 font-semibold rounded-[32px] hover:bg-white hover:text-gray-900 transition-colors"
        >
          Recusar
        </button>
        <button 
          onClick={handleAccept} 
          className="px-6 py-2 bg-[#890083] text-white font-bold border-2 border-[#890083] rounded-[32px] hover:bg-white hover:text-[#890083] transition-colors"
        >
          Aceitar Todos
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;